import { Btn, H6, LI, ProgressBar, UL } from "../../../../AbstractElements";
import { FaDatabase } from "react-icons/fa";
import { Storage } from "../../../../Utils/Constants";

const StoragePlan = () => {
  return (
    <UL>
      <LI className="p-0 border-0">
        <Btn outline color="primary" className="w-100">
          <FaDatabase />
          {Storage}
        </Btn>
        <div className="m-t-15">
          <ProgressBar color="primary" style={{ height: "8px" }} value={30} className="mb-3" />
          <H6 className="f-w-500">{"25 GB of 100 GB used"}</H6>
        </div>
      </LI>
    </UL>
  );
};

export default StoragePlan;
